import { checkEmailAuth, verifyPassport } from '@/api';
import { routes } from '@/constants/routes.const';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { TranslationZone } from '@/styles';
import { CheckEmailPayload } from '@/types/common.type';
import { Passport } from '@repo/components';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';

const PassportPage = () => {
  const { nationality } = useAppSelector((state) => state) as IGlobalState;
  const history = useHistory();
  const dispatch = useAppDispatch();
  const LANG = nationality === 'KOR' ? 'KOR' : 'ENG';

  const { mutate: getPassportInfo } = useMutation(
    (passportNumber: string) => verifyPassport({ passportNumber }),
    {
      onError: (res: any) => {
        alert(res.data.message);
      },
    },
  );

  const { mutate: postVerifiedEmail } = useMutation(
    (payload: CheckEmailPayload) => checkEmailAuth(payload),
    {
      onError: (res: any) => {
        alert(res.data.message);
      },
    },
  );

  const checkEmailVerification = (
    passportNumber: string,
    email?: string,
    onSuccess?: () => void,
  ) => {
    postVerifiedEmail(
      {
        passportNumber,
        email,
      },
      {
        onSuccess: (res) => {
          if (!res) {
            return history.push(routes.inquiryEmail);
          }
          onSuccess && onSuccess();
          history.push(routes.inquiryQna);
        },
      },
    );
  };

  const submitPassport = (passportNumber: string) => {
    if (!passportNumber) {
      return alert('Please enter your passport number.');
    }
    getPassportInfo(passportNumber, {
      onSuccess: (data) => {
        dispatch({
          type: 'UPDATE_USER_INFO',
          payload: {
            passportNumber,
            email: data.email,
            nationality: data.customerNation,
          },
        });
        if (!data.email) {
          return history.push(routes.inquiryEmail);
        }
        checkEmailVerification(passportNumber, data.email, () => {
          dispatch({
            type: 'UPDATE_USER_INFO',
            payload: {
              verifiedEmail: data.email,
            },
          });
        });
      },
    });
  };

  return (
    <>
      <TranslationZone />
      <Passport
        onBackPage={() => history.goBack()}
        onSubmit={submitPassport}
        lang={LANG}
      />
    </>
  );
};
export default PassportPage;
